import React from "react";

import { Box, Typography, Card, CardContent } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

import { CustomShortVideoSuggestion } from "../../../types";

interface SuggestedVideosProps {
  suggestedShortVideos: CustomShortVideoSuggestion[];
  handleOptionSelect: (suggestedVideo: CustomShortVideoSuggestion) => void;
}

export function SuggestedVideos({
  suggestedShortVideos,
  handleOptionSelect,
}: SuggestedVideosProps) {
  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <Box>
      <Typography
        variant="body1"
        sx={{ mb: 3, color: "#6b7280", lineHeight: 1.6 }}
      >
        Select one of the generated video concepts:
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          maxHeight: "400px",
          overflowY: "auto",
        }}
      >
        {suggestedShortVideos?.map((suggestedVideo, index) => (
          <Card
            key={suggestedVideo.title}
            sx={{
              cursor: "pointer",
              transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
              "&:hover": {
                transform: "translateX(4px)",
                boxShadow: "0 4px 16px rgba(25, 118, 210, 0.15)",
                borderColor: "#1976d2",
              },
              border: "1px solid rgba(0, 0, 0, 0.08)",
              borderRadius: 2,
              maxWidth: "98%",
            }}
            onClick={() => handleOptionSelect(suggestedVideo)}
          >
            <CardContent sx={{ py: 2 }}>
              <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                <Box
                  sx={{
                    minWidth: 32,
                    height: 32,
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #1976d2, #1565c0)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: 700,
                    fontSize: "0.875rem",
                  }}
                >
                  {index + 1}
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 600, mb: 1, fontSize: "1rem" }}
                  >
                    {suggestedVideo.title}
                  </Typography>
                  <Box sx={{ display: "flex", gap: 3 }}>
                    <Typography variant="body2" color="text.secondary">
                      <strong>Start:</strong> {formatTime(suggestedVideo.start)}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong>End:</strong> {formatTime(suggestedVideo.end)}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong>Duration:</strong>{" "}
                      {formatTime(suggestedVideo.end - suggestedVideo.start)}
                    </Typography>
                  </Box>
                </Box>
                <PlayArrowIcon sx={{ color: "#1976d2", fontSize: 20 }} />
              </Box>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
}
